
import React from 'react';
import { LockIcon, BellIcon, CreditCardIcon, ShieldCheckIcon } from '../../../../components/icons';

export const QuickActionsCard: React.FC = () => {
    const actions = [
        { icon: <LockIcon className="w-3.5 h-3.5" />, label: 'Alterar Senha' },
        { icon: <BellIcon className="w-3.5 h-3.5" />, label: 'Notificações' },
        { icon: <CreditCardIcon className="w-3.5 h-3.5" />, label: 'Plano e Pagamento' },
        { icon: <ShieldCheckIcon className="w-3.5 h-3.5" />, label: 'Segurança' },
    ];

    return (
        <div className="card-premium p-4">
            <h4 className="text-sm font-semibold text-secondary mb-3">Ações Rápidas</h4>
            <div className="space-y-0.5">
                {actions.map((action, index) => (
                    <button
                        key={index}
                        className="w-full flex items-center space-x-3 px-3 py-1.5 text-left text-xs text-secondary hover:bg-surface rounded-lg transition-colors group"
                    >
                        <span className="p-1.5 bg-surface rounded-md group-hover:bg-card group-hover:shadow-sm transition-all">
                            {action.icon}
                        </span>
                        <span className="font-medium">{action.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};
